import { useEffect, useCallback } from 'react';

type EventHandler = (e: MouseEvent) => void;

const getArrayFormatData = <T>(data: T | T[]): T[] =>
  Array.isArray(data) ? data : [data];

/**
 * 给指定的dom节点外的dom节点 绑定 指定事件的处理函数
 * 监听指定dom节点外的dom节点的 指定事件
 * @param target 需要绑定的dom节点
 * @param eventName 事件名称
 * @param eventHandler 事件处理函数
 */
export default function useClickoutside(
  target: any | any[],
  eventName: string | string[],
  eventHandler: EventHandler,
) {
  const handler = useCallback(
    (e: MouseEvent) => {
      const targets = getArrayFormatData<any>(target);
      const isInner = targets?.some(
        (target) => target === e?.target || target?.contains(e?.target),
      );
      if (isInner) return;
      eventHandler?.(e);
    },
    [target, eventHandler],
  );

  useEffect(() => {
    const eventNames = getArrayFormatData<string>(eventName);

    eventNames?.forEach((eventNameItem) => {
      document?.body?.addEventListener(eventNameItem, handler, false);
    });

    return () => {
      eventNames?.forEach((eventNameItem) => {
        document?.body?.removeEventListener(eventNameItem, handler, false);
      });
    };
  }, [eventName, handler]);
}
